export default __webpack_public_path__ + "static/media/Aflac.b03811d2.svg";